// extracted by mini-css-extract-plugin
module.exports = {"links-row":"footer-links_links-row__KP_7H","category":"footer-links_category__KMeuY","links":"footer-links_links__om_jn","link-item":"footer-links_link-item__V59Ju"};